export default __webpack_public_path__ + "static/media/StaticPage3.bd2bd876.txt";